import { useMemo, useState } from 'react'
import { byId, catalogue } from '../data/catalog'
import { useAppStore } from '../store'
import type { ItemCategory } from '../types'
import { Aquarium } from '../components/Aquarium'
import { ItemPreview } from '../components/DiscoveryModal'
import { Icon } from '../components/Icons'

const filters: { value: ItemCategory | 'all'; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'fish', label: 'Fish' },
  { value: 'plant', label: 'Plants' },
  { value: 'decor', label: 'Decorations' },
  { value: 'background', label: 'Backgrounds' },
]

export function CollectionView() {
  const { state, togglePlacement, setBackground, arrangeForMe } = useAppStore()
  const [filter, setFilter] = useState<ItemCategory | 'all'>('all')
  const [arrange, setArrange] = useState(false)
  const owned = useMemo(() => new Set(state.inventory.map((entry) => entry.itemId)), [state.inventory])
  const filtered = catalogue.filter((item) => filter === 'all' || item.category === filter)

  return (
    <main className="view collection-view">
      <header className="view-header"><div><p className="eyebrow">A record of focused effort</p><h1>Your collection</h1><p>{owned.size} discoveries belong to you permanently.</p></div><button className="secondary" onClick={() => setArrange(!arrange)}>{arrange ? 'Done arranging' : 'Arrange cove'}</button></header>
      {arrange && <section className="arrange-stage"><Aquarium editable /><div className="arrange-toolbar"><span>Drag plants and decorations inside the cove. Use the collection cards below to place or store items.</span><button className="secondary" onClick={arrangeForMe}><Icon name="sparkle" /> Arrange for me</button></div></section>}
      <nav className="filter-row" aria-label="Collection filters">{filters.map((entry) => <button key={entry.value} className={filter === entry.value ? 'active' : ''} onClick={() => setFilter(entry.value)}>{entry.label}</button>)}</nav>
      <section className="collection-grid">
        {filtered.map((item) => {
          const isOwned = owned.has(item.id)
          const isPlaced = state.placements.some((entry) => entry.itemId === item.id)
          const isActiveBg = state.activeBackground === item.id
          return (
            <article className={`collection-card ${!isOwned ? 'locked' : ''}`} key={item.id}>
              <div className="collection-preview">{isOwned ? <ItemPreview itemId={item.id} /> : <div className="locked-silhouette"><ItemPreview itemId={item.id} /><span>?</span></div>}</div>
              <div className="rarity-line"><span className={`rarity rarity-${item.rarity}`}>{item.rarity}</span><span>{item.collection}</span></div>
              <h2>{isOwned ? item.name : 'Undiscovered'}</h2>
              <p>{isOwned ? item.description : item.unlock === 'premium' ? 'Available as an exact cosmetic purchase later.' : 'Discover through focus-earned tickets.'}</p>
              {isOwned && ['plant', 'decor'].includes(item.category) && <button className="secondary wide" onClick={() => togglePlacement(item.id)}>{isPlaced ? 'Store item' : 'Place in cove'}</button>}
              {isOwned && item.category === 'background' && <button className="secondary wide" disabled={isActiveBg} onClick={() => setBackground(item.id)}>{isActiveBg ? 'Active background' : 'Use background'}</button>}
              {isOwned && item.category === 'fish' && <span className="owned-label"><Icon name="check" /> Swimming in your cove</span>}
            </article>
          )
        })}
      </section>
    </main>
  )
}
